import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { SaleOrderDetailDto } from './sale-order-detail.dto';

export class SaleOrderDetailViewResponseModel extends GlobalResponseObject {
    data?: SaleOrderDetailDto[];
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: SaleOrderDetailDto[]){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

